<template>
  <div class="analytics-card">
    <slot />
  </div>
</template>
<script setup lang="ts">
// Basic AnalyticsCard stub
</script>
<style scoped>
.analytics-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 1rem;
}
</style>
